(() => {
  const normalize = (value) => String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]+/g, '');

  const initialize = (root) => {
    if (!root || root.dataset.softwareUpdateReady === 'true') return;

    const input = root.querySelector('[data-update-search]');
    const form = root.querySelector('[data-update-form]');
    const cards = Array.from(root.querySelectorAll('[data-update-plan]'));
    const filters = Array.from(root.querySelectorAll('[data-update-filter]'));
    const status = root.querySelector('[data-update-status]');
    const empty = root.querySelector('[data-update-empty]');
    const reset = root.querySelector('[data-update-reset]');

    if (!input || !form || !cards.length) return;

    let activeCategory = 'all';

    const setStatus = (visible, query, exactPrefixMatch) => {
      if (!status) return;

      if (!query) {
        status.textContent = `${visible} update ${visible === 1 ? 'path' : 'paths'} available`;
      } else if (exactPrefixMatch && visible === 1) {
        status.textContent = 'Update path matched to this serial-number prefix';
      } else {
        status.textContent = `${visible} ${visible === 1 ? 'result' : 'results'} for "${query}"`;
      }
    };

    const applyFilters = () => {
      const rawQuery = input.value.trim();
      const normalizedQuery = normalize(rawQuery);
      const prefixCandidates = [];
      const looksLikeSerial = normalizedQuery.length >= 6;

      if (looksLikeSerial) {
        cards.forEach((card) => {
          const prefixes = (card.dataset.prefixes || '')
            .split(',')
            .map(normalize)
            .filter(Boolean);

          prefixes.forEach((prefix) => {
            if (normalizedQuery.startsWith(prefix)) {
              prefixCandidates.push({ card, prefix });
            }
          });
        });
      }

      prefixCandidates.sort((a, b) => b.prefix.length - a.prefix.length);
      const exactPrefixCard = prefixCandidates.length ? prefixCandidates[0].card : null;
      let visible = 0;

      cards.forEach((card) => {
        const categoryMatch = exactPrefixCard
          ? card === exactPrefixCard
          : activeCategory === 'all' || card.dataset.category === activeCategory;
        let queryMatch = true;

        if (normalizedQuery) {
          queryMatch = exactPrefixCard
            ? card === exactPrefixCard
            : normalize(card.dataset.searchTerms).includes(normalizedQuery);
        }

        const shouldShow = categoryMatch && queryMatch;
        card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      setStatus(visible, rawQuery, Boolean(exactPrefixCard));

      root.classList.toggle('has-query', Boolean(normalizedQuery));
      root.classList.toggle('has-exact-match', Boolean(exactPrefixCard));
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      applyFilters();
      const firstVisible = cards.find((card) => !card.hidden);
      if (firstVisible) {
        firstVisible.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        firstVisible.focus({ preventScroll: true });
      }
    });

    input.addEventListener('input', applyFilters);

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.updateFilter || 'all';
        filters.forEach((button) => button.setAttribute('aria-pressed', String(button === filter)));
        applyFilters();
      });
    });

    if (reset) {
      reset.addEventListener('click', () => {
        input.value = '';
        activeCategory = 'all';
        filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.updateFilter === 'all')));
        applyFilters();
        input.focus();
      });
    }

    root.dataset.softwareUpdateReady = 'true';
    applyFilters();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-software-update-finder]').forEach(initialize);

    scope.querySelectorAll('.software-update__official').forEach((details) => {
      if (details.dataset.officialLookupReady === 'true') return;

      const iframe = details.querySelector('iframe[data-update-src]');
      const summary = details.querySelector('summary');
      if (!iframe || !summary) return;

      const loadIframe = () => {
        if (!iframe.getAttribute('src')) {
          iframe.setAttribute('src', iframe.dataset.updateSrc);
        }
      };

      summary.addEventListener('click', () => {
        if (!details.open) loadIframe();
      });
      details.addEventListener('toggle', () => {
        if (details.open) loadIframe();
      });
      if (details.open) loadIframe();
      details.dataset.officialLookupReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
